module.exports = "https://web-assets-production.autolist.com/_next/static/images/code-bg-b580ee702aadb00f7ec7164324bcd1d0.jpg";